import { Column, Typography } from '@/components'
import { paths } from '@/routes/paths'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface RelatedRecommendationHintProps {
  relatedRecommendationIds?: string[]
}

export const RelatedRecommendationHint = ({
  relatedRecommendationIds = [],
}: RelatedRecommendationHintProps) => {
  const { t } = useTranslation()

  if (relatedRecommendationIds.length === 0) {
    return null
  }

  return (
    <Column gap="4px" data-testid="related-recommendation-hint">
      <Typography variant="p1Body">
        {t('recommendations.relatedRecommendation.hint')}
      </Typography>
      {relatedRecommendationIds.map((id) => (
        <Link key={id} to={paths.viewRecommendationWithKey(id)}>
          {t('recommendations.relatedRecommendation.link')}
        </Link>
      ))}
    </Column>
  )
}
